import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingUnsupportedTransaction = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="220"
        height="200"
        viewBox="0 0 220 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M157.704 34.1141C169.672 50.7756 176.143 67.3865 176.643 83.1311C177.203 98.8778 171.806 113.807 164.679 129.195C157.55 144.533 148.64 160.328 136.676 162.417C124.712 164.455 109.692 152.837 93.2992 146.266C76.8477 139.742 59.0351 138.315 47.9285 128.483C36.8361 118.598 32.5084 100.305 34.7491 82.4693C37.0404 64.6359 46.0013 47.2518 59.7469 30.9546C73.5452 14.5987 92.2294 -0.688485 110.252 0.0239606C128.326 0.73843 145.788 17.4505 157.704 34.1141Z"
          fill="#F9F9F9"
        />
        <rect
          x="0.00195312"
          y="62.6577"
          width="68.4612"
          height="47.0671"
          rx="6"
          transform="rotate(-15.1428 0.00195312 62.6577)"
          fill="#065BDC"
        />
        <rect
          x="2.5708"
          y="72.1564"
          width="68.4612"
          height="7.70189"
          transform="rotate(-15.1428 2.5708 72.1564)"
          fill="#AECCFF"
        />
        <rect
          x="16.3643"
          y="83.8141"
          width="23.9614"
          height="2.99518"
          rx="1.49759"
          transform="rotate(-15.1428 16.3643 83.8141)"
          fill="#AECCFF"
        />
        <path
          d="M147.576 197.003H205.661V85.1378L147.576 85.1378V197.003Z"
          fill="#E8F0FF"
        />
        <path
          d="M205.503 197.003H219.014V85.1378H205.503V197.003Z"
          fill="#B2B2B2"
        />
        <path
          d="M152.387 101.554H200.848V92.2117H152.387V101.554Z"
          fill="#B2B2B2"
        />
        <path
          d="M155.871 97.3521C156.776 97.3521 157.51 96.6181 157.51 95.7126C157.51 94.8072 156.776 94.0732 155.871 94.0732C154.965 94.0732 154.231 94.8072 154.231 95.7126C154.231 96.6181 154.965 97.3521 155.871 97.3521Z"
          fill="#F2F7FF"
        />
        <path
          d="M184.115 95.7123H158.887"
          stroke="#F2F7FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.387 117.345H200.848V108.002H152.387V117.345Z"
          fill="#B2B2B2"
        />
        <path
          d="M155.871 113.142C156.776 113.142 157.51 112.408 157.51 111.503C157.51 110.597 156.776 109.863 155.871 109.863C154.965 109.863 154.231 110.597 154.231 111.503C154.231 112.408 154.965 113.142 155.871 113.142Z"
          fill="#E8F0FF"
        />
        <path
          d="M184.115 111.503H158.887"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.387 133.137H200.848V123.795H152.387V133.137Z"
          fill="#B2B2B2"
        />
        <path
          d="M155.871 128.93C156.776 128.93 157.51 128.196 157.51 127.291C157.51 126.385 156.776 125.651 155.871 125.651C154.965 125.651 154.231 126.385 154.231 127.291C154.231 128.196 154.965 128.93 155.871 128.93Z"
          fill="#F2F7FF"
        />
        <path
          d="M184.115 127.291H158.887"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.387 148.926H200.848V139.583H152.387V148.926Z"
          fill="#B2B2B2"
        />
        <path
          d="M155.871 144.721C156.776 144.721 157.51 143.987 157.51 143.082C157.51 142.176 156.776 141.442 155.871 141.442C154.965 141.442 154.231 142.176 154.231 143.082C154.231 143.987 154.965 144.721 155.871 144.721Z"
          fill="#E8F0FF"
        />
        <path
          d="M184.115 143.081H158.887"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.387 164.716H200.848V155.374H152.387V164.716Z"
          fill="#B2B2B2"
        />
        <path
          d="M155.871 160.511C156.776 160.511 157.51 159.777 157.51 158.872C157.51 157.966 156.776 157.232 155.871 157.232C154.965 157.232 154.231 157.966 154.231 158.872C154.231 159.777 154.965 160.511 155.871 160.511Z"
          fill="#E8F0FF"
        />
        <path
          d="M184.115 158.872H158.887"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.89 98.933H208.621"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.89 100.816H208.621"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.89 111.734H208.621"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.89 113.615H208.621"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.89 127.291H208.621"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.89 129.174H208.621"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.89 142.343H208.621"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M215.89 144.224H208.621"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.87 110.677C131.913 111.514 139.401 117.023 142.468 120.51C145.313 121.268 157.644 125.819 168.43 127.417C168.396 128.891 167.617 133.801 167.617 133.801C167.617 133.801 141.654 130.674 138.524 129.842C135.395 129.01 123.2 121.834 120.529 119.122C124.089 115.471 130.87 110.677 130.87 110.677Z"
          fill="#FFB688"
        />
        <path
          d="M168.251 134.168C171.251 134.168 173.684 132.364 173.684 130.139C173.684 127.913 171.251 126.109 168.251 126.109C165.251 126.109 162.819 127.913 162.819 130.139C162.819 132.364 165.251 134.168 168.251 134.168Z"
          fill="#FFB688"
        />
        <path
          d="M91.6602 147.121V200H109.633L100.647 147.693L91.6602 147.121Z"
          fill="#065BDC"
        />
        <path
          d="M121.808 149.213V200H107.362L95.689 146.58L121.808 149.213Z"
          fill="#74AAFF"
        />
        <path
          d="M87.9671 112.378C87.1462 113.267 84.8222 116.136 84.2083 117.23C82.6371 115.864 56.3229 91.6688 55.7066 91.6688C55.4293 91.6728 55.1635 91.7801 54.9611 91.9698C54.7588 92.1595 54.6346 92.4179 54.6128 92.6943C54.6128 95.9002 56.9514 96.0585 59.8552 99.1377C65.9453 110.068 80.5348 129.873 84.3423 129.873C86.5347 129.873 95.687 120.938 95.687 119.766C95.687 118.594 87.9671 112.378 87.9671 112.378Z"
          fill="#FFB688"
        />
        <path
          d="M100.739 99.2182C94.6488 95.5397 84.9606 109.031 85.1482 111.286C85.3358 113.542 94.2834 120.107 98.0203 119.376C100.471 118.889 107.104 103.055 100.739 99.2182Z"
          fill="#0F3893"
        />
        <path
          d="M109.246 94.838C127.309 94.838 126.13 146.049 122.929 148.636C118.946 151.856 93.0948 148.879 91.66 147.12C90.2252 145.362 89.1704 94.838 109.246 94.838Z"
          fill="#0F3893"
        />
        <path
          d="M114.322 97.8562C114.322 99.3666 105.95 99.6906 105.95 97.8562V87.5761H114.322V97.8562Z"
          fill="#DB9D76"
        />
        <path
          d="M115.84 85.9323C117.886 80.7562 116.422 75.3255 112.57 73.8026C108.718 72.2797 103.936 75.2412 101.89 80.4173C99.8434 85.5934 101.308 91.024 105.16 92.5469C109.012 94.0699 113.794 91.1084 115.84 85.9323Z"
          fill="#FFB688"
        />
        <path
          d="M116.162 87.9401C116.932 86.8645 116.946 85.5561 116.195 85.0177C115.443 84.4793 114.209 84.9147 113.438 85.9903C112.668 87.0659 112.654 88.3743 113.405 88.9128C114.157 89.4512 115.391 89.0157 116.162 87.9401Z"
          fill="#FFB688"
        />
        <path
          d="M122.598 81.9393C122.598 80.5434 121.295 79.016 121.049 77.2499C120.922 76.3607 121.197 72.6604 120.159 71.4034C118.004 68.809 116.729 69.34 115.08 68.7237C112.206 67.6738 111.105 65.932 108.732 65.932C106.038 65.932 104.949 67.3279 103.019 67.3279C100.812 67.3279 99.0048 66.312 95.9086 66.312C94.257 66.312 92.0986 68.4704 92.0986 70.3754C92.0986 74.8772 96.2886 74.2316 96.2886 75.3278C96.2886 76.0879 96.045 76.692 96.045 77.7395C96.045 79.1037 97.8233 79.8979 98.8392 79.8979C101.933 79.8979 102.342 79.5203 102.342 79.5203C102.957 78.2932 103.742 77.159 104.673 76.1512C104.798 76.0197 106.807 77.4399 110.089 77.5495C112.781 77.6396 114.673 78.1585 114.673 79.4131C114.673 80.2974 114.349 82.9259 114.369 83.6664C114.388 84.407 114.652 84.8844 114.817 84.8844C114.983 84.8844 115.075 84.6408 116.108 84.6408C117.217 84.6408 117.302 86.0026 117.494 86.0026C118.598 86.027 122.598 85.1232 122.598 81.9393Z"
          fill="#0B0B0B"
        />
        <path
          d="M117.468 99.9928C123.558 96.312 133.248 109.805 133.058 112.059C132.868 114.312 123.933 120.877 120.194 120.149C117.738 119.671 111.105 103.837 117.468 99.9928Z"
          fill="#0F3893"
        />
        <path
          d="M60.4886 98.6019C59.7968 99.0493 59.2162 99.6486 58.7909 100.354C58.3656 101.06 58.1068 101.853 58.0342 102.674C57.9617 103.495 58.0772 104.321 58.3722 105.09C58.6671 105.86 59.1335 106.552 59.7361 107.113C60.3387 107.675 61.0614 108.092 61.8494 108.333C62.6374 108.573 63.4699 108.631 64.2835 108.501C65.0972 108.372 65.8705 108.058 66.5447 107.585C67.2189 107.111 67.7763 106.49 68.1744 105.769L60.4886 98.6019Z"
          fill="#FFB688"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.9038 31.1956C44.1397 36.9497 41.4645 44.2889 40.4643 49.2902L39.9824 49.1938C40.9941 44.1356 43.6962 36.7148 48.5252 30.8822C53.3609 25.0416 60.3438 20.7807 69.8872 22.1123C76.1693 22.9889 81.2801 24.6434 85.5137 27.2732C89.7492 29.9042 93.0938 33.5033 95.8545 38.2492L95.4298 38.4963C92.7035 33.8095 89.4123 30.2734 85.2544 27.6906C81.0947 25.1068 76.0545 23.4691 69.8193 22.599C60.4872 21.2969 53.6612 25.4494 48.9038 31.1956ZM163.726 49.5728C153.259 44.6381 141.091 44.4464 130.783 45.4384L130.735 44.9493C141.073 43.9545 153.349 44.1368 163.935 49.1284C174.539 54.1281 183.415 63.9368 186.968 82.117L186.485 82.2112C182.96 64.1692 174.175 54.4994 163.726 49.5728Z"
          fill="#0B0B0B"
        />
        <path
          d="M127.108 40.8675C127.163 40.7504 127.298 40.6952 127.418 40.7451C129.128 41.4612 131.691 43.1329 131.071 45.2801C130.15 48.4735 126.616 47.1849 124.718 46.6687C124.569 46.628 124.491 46.4625 124.557 46.3221L125.355 44.6159L126.28 42.6376L127.108 40.8675Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.845 46.3986C124.98 46.4357 125.121 46.4757 125.267 46.5171C126.169 46.7731 127.256 47.0815 128.258 47.0714C128.841 47.0655 129.367 46.9501 129.796 46.6706C130.218 46.3947 130.574 45.9401 130.788 45.1987C131.055 44.2727 130.651 43.4241 129.91 42.6843C129.184 41.9594 128.179 41.389 127.353 41.0375L124.845 46.3986ZM124.641 46.9528C124.317 46.8647 124.146 46.5055 124.29 46.1976L126.841 40.743C126.96 40.4883 127.261 40.3607 127.531 40.4739C128.406 40.8403 129.512 41.4555 130.326 42.2679C131.139 43.0797 131.706 44.1406 131.353 45.3618C131.107 46.217 130.676 46.7989 130.117 47.1634C129.564 47.5243 128.916 47.6533 128.264 47.6599C127.168 47.6709 125.983 47.3334 125.087 47.0779C124.928 47.0329 124.779 46.9904 124.641 46.9528Z"
          fill="#0B0B0B"
        />
        <path
          d="M98.1846 42.5346C98.1286 42.6512 97.9924 42.705 97.8736 42.6538C96.1749 41.9215 93.6364 40.2272 94.2766 38.0918C95.2287 34.916 98.7399 36.2376 100.628 36.7724C100.777 36.8147 100.853 36.981 100.786 37.1207L99.9724 38.8139L99.0288 40.7779L98.1846 42.5346Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M102.779 39.9394C102.719 40.0902 102.547 40.1634 102.396 40.1029L100.119 39.1895L99.4306 40.6218L101.672 41.5205C101.823 41.581 101.896 41.7523 101.835 41.9031C101.775 42.0539 101.604 42.1272 101.453 42.0667L99.1752 41.1534L98.4503 42.662C98.3285 42.9155 98.0267 43.04 97.7575 42.924C96.8881 42.5492 95.7915 41.9239 94.9884 41.105C94.1858 40.2866 93.631 39.2222 93.9952 38.0073C94.2502 37.1566 94.6864 36.5805 95.2473 36.2226C95.8027 35.8681 96.4511 35.7462 97.1018 35.7464C98.1947 35.7466 99.3737 36.0958 100.266 36.36C100.423 36.4065 100.571 36.4504 100.709 36.4893C101.031 36.5807 101.199 36.9417 101.052 37.2481L100.374 38.6579L102.615 39.5568C102.766 39.6172 102.839 39.7886 102.779 39.9394ZM100.498 37.0413C100.364 37.003 100.224 36.9617 100.079 36.9189C99.1818 36.6541 98.1006 36.3351 97.1016 36.3348C96.5195 36.3347 95.9936 36.4444 95.5639 36.7187C95.1396 36.9894 94.7799 37.4391 94.5589 38.1763C94.2829 39.0968 94.6773 39.9473 95.4085 40.6929C96.125 41.4235 97.1213 42.003 97.9415 42.3623L100.498 37.0413Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.433 32.4392C105.592 32.4732 105.693 32.6297 105.659 32.7886L104.922 36.2284C104.888 36.3873 104.731 36.4885 104.572 36.4544C104.414 36.4204 104.312 36.264 104.346 36.1051L105.084 32.6653C105.118 32.5064 105.274 32.4051 105.433 32.4392Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110.168 42.7624C110.119 42.9172 109.953 43.0025 109.798 42.9529L106.448 41.8799C106.293 41.8304 106.208 41.6647 106.258 41.51C106.307 41.3552 106.473 41.2699 106.628 41.3195L109.978 42.3925C110.133 42.442 110.218 42.6077 110.168 42.7624Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110.557 36.2996C110.619 36.4497 110.548 36.6219 110.398 36.6842L106.85 38.1573C106.7 38.2196 106.527 38.1485 106.465 37.9984C106.403 37.8483 106.474 37.6761 106.624 37.6138L110.172 36.1407C110.323 36.0784 110.495 36.1496 110.557 36.2996Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M101.706 45.1083C101.866 45.1347 101.974 45.2862 101.948 45.4465L101.485 48.2539C101.458 48.4143 101.307 48.5228 101.147 48.4964C100.986 48.4699 100.878 48.3185 100.904 48.1581L101.367 45.3507C101.394 45.1904 101.545 45.0818 101.706 45.1083Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M104.696 44.0452C104.823 43.9435 105.008 43.9638 105.109 44.0905L106.716 46.0926C106.818 46.2193 106.798 46.4045 106.671 46.5062C106.544 46.608 106.359 46.5877 106.257 46.4609L104.65 44.4588C104.549 44.3321 104.569 44.1469 104.696 44.0452Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M123.58 51.8206C123.419 51.803 123.302 51.6577 123.32 51.4962L123.702 47.9991C123.719 47.8375 123.865 47.7209 124.026 47.7385C124.188 47.7561 124.304 47.9014 124.287 48.0629L123.905 51.5601C123.887 51.7216 123.742 51.8383 123.58 51.8206Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M118.089 48.5036C118.012 48.3607 118.065 48.1822 118.208 48.1049L121.587 46.277C121.73 46.1997 121.909 46.2529 121.986 46.3958C122.063 46.5387 122.01 46.7173 121.867 46.7946L118.488 48.6225C118.345 48.6998 118.166 48.6466 118.089 48.5036Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M125.994 38.8371C125.832 38.8271 125.709 38.6876 125.718 38.5254L125.892 35.6853C125.902 35.5231 126.042 35.3997 126.204 35.4096C126.366 35.4196 126.49 35.5591 126.48 35.7213L126.306 38.5614C126.296 38.7236 126.156 38.847 125.994 38.8371Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M121.829 42.738C121.846 42.8997 121.728 43.0442 121.566 43.0608L118.576 43.3678C118.414 43.3844 118.27 43.2668 118.253 43.1052C118.236 42.9435 118.354 42.799 118.516 42.7824L121.506 42.4754C121.668 42.4588 121.812 42.5764 121.829 42.738Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M123.128 40.1998C123.012 40.3139 122.826 40.3127 122.712 40.197L120.909 38.3695C120.795 38.2538 120.796 38.0675 120.912 37.9534C121.028 37.8392 121.214 37.8405 121.328 37.9562L123.131 39.7837C123.245 39.8994 123.244 40.0857 123.128 40.1998Z"
          fill="#ED9F38"
        />
      </svg>
    );
  }
);
export default BillingUnsupportedTransaction;
